import React, {useRef, useState} from "react";
import Icon from "@mdi/react";
import {mdiChevronLeft, mdiFileDownloadOutline, mdiFileUploadOutline} from "@mdi/js";
import {useTranslations} from "../../../hooks/useTranslations";
import {project} from "../../../system/types/project/project";
import {ProjectApi} from "../../../system/api/ProjectApi";
import {dispatch} from "../../../App";
import {actions} from "../../../redux";
import {useNavigate} from "react-router-dom";
import {initialProject} from "../../../system/initial/project";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/reducers";

interface props {
    showBackupStatus: string;
    setShowBackupStatus: React.Dispatch<React.SetStateAction<string>>;
}

const ListProjectBackup = (props: props) => {

    const {t} = useTranslations();
    const navigate = useNavigate();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');

    const [projectId, setProjectId] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const fileInputRef = useRef<HTMLInputElement>(null);


    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }

        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
    });


    const downloadProject = () => {
        const blob = new Blob([JSON.stringify(projectData, null, 2)], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);

        const filename = projectData.name + '.json';

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Dateiname
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    const uploadProject = () => {
        if (fileInputRef.current === null) {
            return;
        }
        fileInputRef.current.click();
    }

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]; // Die hochgeladene Datei
        if (file) {
            const reader = new FileReader(); // FileReader zum Lesen der Datei

            // Wenn die Datei geladen wurde, verarbeiten wir sie
            reader.onload = (e) => {
                const aktProjectId = projectData._id;
                let json = null;
                try {
                    json = JSON.parse(e.target?.result as string) as project; // JSON parsen
                } catch (error) {
                    console.error("Fehler beim Parsen der JSON-Datei:", error);
                    return;
                }

                if (json === null) {
                    return;
                }

                save(aktProjectId, json);
            };

            reader.readAsText(file); // Datei als Text lesen
        }
    };

    const save = async (aktProjectId: string, saveProjectData: project) => {
        const newProjectData = {
            ...saveProjectData,
            _id: aktProjectId,
            accountId: sessionEmail,
        };

        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.saveProject(projectId, newProjectData, true);

        if (result._id) {
            dispatch(actions.project.setData(result))
            navigate('/projects/' + result._id );
        }
    };

    const closeList = () => {
        props.setShowBackupStatus('close');
    }

    return (<>
            <div className="row mb-3 align-items-center">
            <span className="link" onClick={closeList}>
                <Icon path={mdiChevronLeft} size={1}/> {t('common.back')}
            </span>
            </div>
            <div className="row mb-3 align-items-center">
                <div className="col">{t('projects.backupprojecttofile')}</div>
                <div className="col-auto">
                    <button onClick={downloadProject} className="btn  btn-outline-primary"><Icon
                        path={mdiFileDownloadOutline} size={1}/></button>
                </div>
            </div>
            <div className="row mb-3 align-items-center">
                <div className="col">{t('projects.restoreprojectfromfile')}</div>
                <div className="col-auto">
                    <button onClick={uploadProject} className="btn  btn-outline-primary"><Icon
                        path={mdiFileUploadOutline} size={1}/></button>
                </div>
            </div>
            <input
                type="file"
                accept=".json"
                ref={fileInputRef}
                style={{display: 'none'}} // Das Input-Element wird versteckt
                onChange={handleFileUpload}
            />

        </>
    );
}

export { ListProjectBackup };
